const INITIALIZE_GAME = 'Initialize game'
const START_GAME = 'Start game'
const END_GAME = 'End game'
const PAUSE_GAME = 'Pause game'

export default {
  INITIALIZE_GAME,
  START_GAME,
  END_GAME,
  PAUSE_GAME
}



// WEBPACK FOOTER //
// ./src/app/reducers/constants/gameConstants.js